"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RowBandingStylist;
(function (RowBandingStylist) {
    /**
     * Creates a row stylist that applies background color suitable for row banding (hover too).
     */
    function create(bandingConfig) {
        return function (rowArgs) {
            if (rowArgs.isSelected && bandingConfig.selectedColor) {
                rowArgs.style.backgroundColor = bandingConfig.selectedColor;
            }
            else if (rowArgs.isHovered && bandingConfig.hoverColor) {
                rowArgs.style.backgroundColor = bandingConfig.hoverColor;
            }
            else if (rowArgs.rowIdx % 2 === 0) {
                rowArgs.style.backgroundColor = bandingConfig.altRowColor || rowArgs.style.backgroundColor;
            }
            return rowArgs;
        };
    }
    RowBandingStylist.create = create;
})(RowBandingStylist = exports.RowBandingStylist || (exports.RowBandingStylist = {}));
//# sourceMappingURL=RowBandingStylist.js.map